import crc32 from 'crc32';
import { nanoid } from 'nanoid/non-secure';

export const generateSystemName = () => {
	const url = new URL(window.location);
	const paramValue = url.searchParams.get('systemName');

	if (paramValue && paramValue.length > 0) {
		return paramValue;
	}

	return crc32(`${Date.now()}-${nanoid()}`);
};
